import { useEffect } from "react";

let listenerIdCounter = 0;
const activeListeners = new Map();

export const GlobalKeyListener = ({
  triggerKeys,
  onTrigger,
  enabled = true,
}) => {
  useEffect(() => {
    if (!enabled) return;

    const listenerId = ++listenerIdCounter;
    activeListeners.set(listenerId, { triggerKeys, onTrigger });

    const handleKeyDown = (e) => {
      const latestId = Math.max(...activeListeners.keys());
      const latestListener = activeListeners.get(latestId);

      if (latestListener && latestListener.triggerKeys.includes(e.key)) {
        e.preventDefault();
        latestListener.onTrigger();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      activeListeners.delete(listenerId);
    };
  }, [triggerKeys, onTrigger, enabled]);

  return null;
};
